// extracted by mini-css-extract-plugin
export default {"root":"aUTn40","title":"uA3WeV","link":"NQQqMp","active":"yYZHKs","reviewsCount":"QWiP5U"};